<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['code', validatorRules.code]" :trigger-change="true" dictCode="biz_operation_type" placeholder="请选择操作类型" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" placeholder="请输入描述"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="操作分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['category']" :trigger-change="true" dictCode="inventory_operation_group" placeholder="请选择操作分组" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['account']" placeholder="请输入科目"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="移动类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['moveType', validatorRules.moveType]" placeholder="请输入移动类型"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="第三方系统编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['thirdSysCode']" placeholder="请输入第三方系统编码"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer1']" placeholder="请输入拓展属性"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer2']" placeholder="请输入拓展属性"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer3']" placeholder="请输入拓展属性"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer4']" placeholder="请输入拓展属性"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="拓展属性" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer5']" placeholder="请输入拓展属性"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['notes']" :placeholder="$t('label.pleaseEnterANote')"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['sortOrder']" placeholder="请输入排序字段" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EfsMdOperationTypeForm',
    components: {
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: '请输入编码!'},
            ]
          },
          moveType: {
            rules: [
              { required: true, message: '请输入移动类型!'},
            ]
          },
        },
        url: {
          add: "/system/efsMdOperationType/add",
          edit: "/system/efsMdOperationType/edit",
          queryById: "/system/efsMdOperationType/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','name','category','account','moveType','thirdSysCode','syncStatus','syncMsg','lockStatus','buffer1','buffer2','buffer3','buffer4','buffer5','notes','tenantCode','sortOrder'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','category','account','moveType','thirdSysCode','syncStatus','syncMsg','lockStatus','buffer1','buffer2','buffer3','buffer4','buffer5','notes','tenantCode','sortOrder'))
      },
    }
  }
</script>